/**
 * @Description 集客点tab相关表单
 */

import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import { Col, Row } from 'antd';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import ShopInfoTableForm from './ShopInfoTableForm';
import CompareTableForm from './CompareTableForm';
import FormSetName from '@/common/components/Form/FormSetName';

const TabForm = ({ keyName, tableFormLength, setTableFormLength, formDisabled }) => {

  return (
    <div className={styles.tabFormWrap}>
      <V2Title type='H2' divider text='集客点' />
      <div style={{
        paddingTop: 320
      }}>

      </div>
      <Row gutter={24} className='mt-16'>
        <FormSetName name={[keyName, 'id']}></FormSetName>
        <Col span={8}>
          <V2FormInput required label='集客点名称' maxLength={32} name={[keyName, 'name']}
            placeholder='以签约店名为主，举例：武汉融创智谷店'
            disabled={formDisabled}
          />
        </Col>
        {/* <Col span={8}>
          <V2FormInput required label='集客A类点' maxLength={32} name={[keyName, 'pointName']} />
        </Col> */}
        <Col span={8}>
          <V2FormInput required label='首选店铺' maxLength={32} name={[keyName, 'firstShop']} disabled={formDisabled} />
        </Col>
        <Col span={8}>
          <V2FormInput label='次选店铺' maxLength={32} name={[keyName, 'secondShop']} disabled={formDisabled}/>
        </Col>
        <Col span={8}>
          <V2FormInputNumber required max={9999999999999999} label='租金单价行情' name={[keyName, 'rent']} config={{ addonAfter: '㎡/月/元' }} disabled={formDisabled}/>
        </Col>
        <Col span={8}>
          <V2FormInputNumber required label='转让费行情' name={[keyName, 'assignmentFee']} config={{ addonAfter: '元' }} disabled={formDisabled} />
        </Col>
        {/* <Col span={8}>
          <V2FormInputNumber required label='预估日均金额' name={[keyName, 'estimatedDailyAmount']} config={{ addonAfter: '元' }} />
        </Col> */}
        <Col span={16}>
          <V2FormUpload
            required
            label='上传动线视频讲解'
            name={[keyName, 'videoUrls']}
            config={{
              maxCount: 5,
              size: 500,
              fileType: ['mov', 'mp4', '3gp', 'm3u8']
            }}
            rules={[{ required: true, message: `请上传动线视频讲解` }]}
            disabled={formDisabled}
          />
        </Col>
        <Col span={8}>
          <V2FormTextArea label='视频备注' placeholder='请输入请输入视频备注，最多200字' maxLength={200} name={[keyName, 'videoRemark']} disabled={formDisabled}/>
        </Col>
      </Row>
      <CompareTableForm
        keyName={keyName}
        tableFormLength={tableFormLength}
        setTableFormLength={setTableFormLength}
        formDisabled={formDisabled}/>
      <ShopInfoTableForm
        keyName={keyName}
        tableFormLength={tableFormLength}
        setTableFormLength={setTableFormLength}
        formDisabled={formDisabled}/>
    </div>
  );
};

export default TabForm;
